import { createResourceCollection } from '@/request'
import { VehicleChargingDelayEvent } from '@/types'

export const vehicleDemandResponseEventsCollection =
  createResourceCollection<VehicleChargingDelayEvent>({
    name: 'vehicleDemandResponseEvents',
    apiConfig: {
      path: 'vehicle_charging_delay_events',
    },
    selector: (state) => state.vehicleDemandResponseEvents,
  })

export default vehicleDemandResponseEventsCollection.slice.reducer
